module.exports = __webpack_public_path__ + "img/start-button-image.b7fd6219.png";